import { createContext, useContext } from 'react';

const UploadFolderIdContext = createContext(null);

export const useUploadFolderId = () => useContext(UploadFolderIdContext);

export const UploadFolderIdProvider = ({ folderId, children }) => (
  <UploadFolderIdContext.Provider value={folderId}>
    {children}
  </UploadFolderIdContext.Provider>
);